import { client } from './client';

export const reportPermissionsApi = {
  getPermissions: () => client.get('get_report_permissions'),
  savePermission: (report_key, allowed_roles) => client.post('save_report_permissions', { report_key, allowed_roles }),
  getEmployeePermissions: () => client.get('get_employee_permissions'),
  saveEmployeePermission: (employee_id, permission_key, granted) =>
    client.post('save_employee_permission', { employee_id, permission_key, granted }),
};
